import { FormattedDate, FormattedTime } from "react-intl";

export default function FormattedDateTime({ value }) {
    return <>
        <FormattedDate value={value} /> <FormattedTime value={value} />
    </>
}